/* ninety-v2.js : presentation behavior for sections/ninety-top-v2.liquid.
   The purchase engine (cart links, sticky bar, gallery, accordion, modal)
   stays in assets/ninety.js. This file only adds:
     1) today's date in the visitor's time zone for every [data-v2-date]
     2) panels marked [data-v2-show="0 1"] follow the selected option
     3) radio semantics and keyboard support for the option tiles
     4) "View Nutrition Label" jumps the gallery to the label image
     5) keyboard support for gift tiles that open the welcome kit popup
     6) page chrome: header pinned from the top (announcement bar hidden)
        and the mobile bottom docked Add To Cart bar */
(function () {
  'use strict';

  var MONTHS = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];

  function todayLabel() {
    var d = new Date();
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function setDates(root) {
    var label = todayLabel();
    var els = root.querySelectorAll('[data-v2-date]');
    for (var i = 0; i < els.length; i++) els[i].textContent = label;
  }

  function initOptionPanels(root) {
    var opts = root.querySelectorAll('[data-nt-options] [data-nt-option]');
    if (!opts.length) return;
    var panels = root.querySelectorAll('[data-v2-show]');

    function activeIndex() {
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].classList.contains('active')) return i;
      }
      return 0;
    }

    function sync() {
      var idx = String(activeIndex());
      for (var p = 0; p < panels.length; p++) {
        var list = (panels[p].getAttribute('data-v2-show') || '').split(/\s+/);
        panels[p].hidden = list.indexOf(idx) === -1;
      }
      for (var o = 0; o < opts.length; o++) {
        var on = String(o) === idx;
        opts[o].setAttribute('aria-checked', on ? 'true' : 'false');
        opts[o].setAttribute('tabindex', on ? '0' : '-1');
      }
    }

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      for (var m = 0; m < opts.length; m++) {
        mo.observe(opts[m], { attributes: true, attributeFilter: ['class'] });
      }
    }
    for (var c = 0; c < opts.length; c++) {
      opts[c].addEventListener('click', function () { window.setTimeout(sync, 0); });
    }

    for (var k = 0; k < opts.length; k++) {
      (function (idx) {
        opts[idx].addEventListener('keydown', function (e) {
          var key = e.key;
          if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            opts[idx].click();
            return;
          }
          var step = 0;
          if (key === 'ArrowRight' || key === 'ArrowDown') step = 1;
          if (key === 'ArrowLeft' || key === 'ArrowUp') step = -1;
          if (!step) return;
          e.preventDefault();
          var next = (idx + step + opts.length) % opts.length;
          opts[next].click();
          opts[next].focus();
        });
      })(k);
    }

    sync();
  }

  function initLabelJump(root) {
    var links = root.querySelectorAll('[data-v2-label-link]');
    if (!links.length) return;
    var stage = root.querySelector('[data-nt-gallery-stage]');
    var gallery = root.querySelector('[data-nt-gallery]');
    var slides = root.querySelectorAll('[data-nt-slide]');
    var thumbs = root.querySelectorAll('[data-nt-thumb]');
    var labelIdx = -1;
    for (var s = 0; s < slides.length; s++) {
      if (slides[s].hasAttribute('data-v2-label-slide')) { labelIdx = s; break; }
    }
    if (labelIdx === -1 || !stage) {
      for (var h = 0; h < links.length; h++) links[h].hidden = true;
      return;
    }

    function headerOffset() {
      var offset = 12;
      var header = document.querySelector('.site-header, header, #shopify-section-header');
      if (header) {
        var pos = getComputedStyle(header).position;
        if (pos === 'fixed' || pos === 'sticky') offset += header.getBoundingClientRect().height;
      }
      var drop = document.getElementById('nav-drop-new');
      // Only count the drop bar when it sits at the top (desktop); on mobile it docks to the bottom.
      if (drop && drop.classList.contains('is-visible') && drop.getBoundingClientRect().top < 5) {
        offset += drop.getBoundingClientRect().height;
      }
      return offset;
    }

    function jump(e) {
      e.preventDefault();
      if (thumbs[labelIdx]) {
        thumbs[labelIdx].click();
      } else {
        stage.scrollTo({ left: labelIdx * stage.clientWidth, behavior: 'smooth' });
      }
      var target = gallery || stage;
      var rect = target.getBoundingClientRect();
      var needsScroll = rect.top < headerOffset() || rect.top > window.innerHeight * 0.35;
      if (needsScroll) {
        window.scrollTo({ top: window.pageYOffset + rect.top - headerOffset(), behavior: 'smooth' });
      }
    }

    for (var i = 0; i < links.length; i++) links[i].addEventListener('click', jump);
  }

  function initGiftKeys(root) {
    var gifts = root.querySelectorAll('.v2-gift[role="button"]');
    for (var i = 0; i < gifts.length; i++) {
      gifts[i].addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    }
  }

  /* Keep the full desktop gallery visible as the taller offer column scrolls.
     The CSS sticks the left column inside its flex row; measuring its height
     lets short viewports reveal the bottom of the gallery and thumbnails. */
  function initDesktopGallery(root) {
    var left = root.querySelector('.nt-col--left');
    if (!left) return;
    var header = document.querySelector('.drop-header');
    function measure() {
      var galleryH = Math.ceil(left.getBoundingClientRect().height);
      if (galleryH) left.style.setProperty('--v2-gallery-height', galleryH + 'px');
      var headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 72;
      left.style.setProperty('--v2-gallery-header', (headerH + 10) + 'px');
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(measure);
      observer.observe(left);
      if (header) observer.observe(header);
    } else {
      window.addEventListener('load', measure, { once: true });
    }
  }

  /* Page chrome for this template only (CSS lives in snippets/ninety-v2-chrome).
     1. The announcement bar is hidden. drop-header.js pins the header after a
        hardcoded 44px of scroll, which would let the header scroll away and snap
        back. Keep it pinned from 0px using the theme's own mechanism
        (.is-stuck plus a top margin on the next section), so nothing shifts.
     2. On mobile the drop bar docks to the bottom. Publish its height as
        --v2-dock-h (page padding and floating widget offsets) and mark it
        ready once ninety.js has written a real cart link into it. */
  function initChrome() {
    var body = document.body;
    if (!body || !body.classList.contains('page-ruff90-onetime-v2')) return;
    if (body.getAttribute('data-v2-chrome') === 'true') return;
    body.setAttribute('data-v2-chrome', 'true');

    var header = document.querySelector('.drop-header');
    var ann = document.querySelector('.drop-announcement');
    var annHidden = !ann || ann.offsetHeight === 0;
    var section = header && header.closest('.shopify-section');
    var next = section && section.nextElementSibling;
    // Cache the height: reading offsetHeight inside pin() would force a layout while
    // drop-header.js has just unpinned the header, and scroll anchoring would then
    // shift the page by the header height. Height is refreshed only on resize.
    var headerH = header ? header.offsetHeight : 0;
    function pin() {
      if (!header || !annHidden) return;
      if (!header.classList.contains('is-stuck')) header.classList.add('is-stuck');
      var h = headerH + 'px';
      if (next && next.style.marginTop !== h) next.style.marginTop = h;
    }
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    function onScroll() { pin(); raf(pin); } // rAF: win over drop-header.js whatever the listener order
    pin();
    window.addEventListener('scroll', onScroll, { passive: true });
    function remeasure() {
      if (!header) return;
      var h = header.offsetHeight;
      if (h && h !== headerH) { headerH = h; pin(); }
    }
    if (header && 'ResizeObserver' in window) {
      new ResizeObserver(remeasure).observe(header);
    } else {
      window.addEventListener('resize', remeasure);
    }

    var drop = document.getElementById('nav-drop-new');
    if (!drop) return;
    var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    function dockVar() {
      var rootStyle = document.documentElement.style;
      if (mq && mq.matches) rootStyle.setProperty('--v2-dock-h', drop.offsetHeight + 'px');
      else rootStyle.removeProperty('--v2-dock-h');
    }
    function markReady() {
      var cta = drop.querySelector('.drop-cta');
      var href = cta && cta.getAttribute('href');
      if (href && href !== '#') {
        drop.setAttribute('data-v2-ready', 'true');
        dockVar();
        return true;
      }
      return false;
    }
    if (!markReady()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (markReady() || tries > 50) clearInterval(timer);
      }, 100);
    }
    dockVar();
    if ('ResizeObserver' in window) {
      new ResizeObserver(dockVar).observe(drop);
    } else {
      window.addEventListener('resize', dockVar);
    }
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', dockVar);
      else if (mq.addListener) mq.addListener(dockVar);
    }
  }

  function init(root) {
    if (!root || root.dataset.v2Init === 'true') return;
    root.dataset.v2Init = 'true';
    setDates(root);
    initOptionPanels(root);
    initLabelJump(root);
    initGiftKeys(root);
    initChrome();
    initDesktopGallery(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-v2-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();


